import { MasterRow } from "./MasterRow";

export const MasterTable = ({ items, fields, bulk, testPrefix, selected, setSelected, editId, setEditId, editForm, setEditForm, save, remove }) => (
  <table className="w-full text-sm">
    <thead>
      <tr className="border-b border-slate-200 bg-slate-50 text-left text-xs font-semibold uppercase tracking-wider text-slate-500">
        {bulk && (
          <th className="w-10 p-3">
            <input type="checkbox" data-testid={`${testPrefix}-select-all`}
              checked={items.length > 0 && selected.length === items.length}
              onChange={() => setSelected(selected.length === items.length ? [] : items.map((i) => i.id))}
              className="h-4 w-4 accent-slate-900" />
          </th>
        )}
        {fields.map((f) => <th key={f.key} className="p-3">{f.label}</th>)}
        <th className="p-3" />
      </tr>
    </thead>
    <tbody data-testid={`${testPrefix}-table-body`}>
      {items.length === 0 && (
        <tr><td colSpan={fields.length + (bulk ? 2 : 1)} className="p-5 text-center text-slate-400">No entries yet.</td></tr>
      )}
      {items.map((item) => (
        <MasterRow key={item.id} item={item} fields={fields} bulk={bulk} testPrefix={testPrefix}
          selected={selected} setSelected={setSelected} isEditing={editId === item.id}
          setEditId={setEditId} editForm={editForm} setEditForm={setEditForm} save={save} remove={remove} />
      ))}
    </tbody>
  </table>
);
